import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tab } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Badge from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Badge';

const styles = theme => ({
  root: {
    textTransform: 'none',
    color: theme.palette.primary.main,
    fontSize: theme.typography.h6.fontSize,
    marginRight: theme.spacing(1),
    opacity: 0.7,
    fontWeight: theme.typography.fontWeightFacetMedium,
    '&:focus': {
      opacity: 1,
    },
    '&:hover': {
      opacity: 1,
    },
    '&.Mui-selected': {
      opacity: 1,
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightFacetBold,
    },
  },
  wrapper: {},
  sm: {
    minWidth: 'auto',
  },
});

const FacetTab = ({
  className, classes, value, label, actionNeeded, errorCount, warningCount, size, ...rest
}) => {
  const badgeProps = {
    invisible: !actionNeeded,
    variant: 'dot',
    color: 'orange',
  };

  if (errorCount && errorCount !== '0') {
    badgeProps.invisible = false;
    badgeProps.color = 'red';
  } else if (warningCount && warningCount !== '0') {
    badgeProps.invisible = false;
    badgeProps.color = 'orange';
  }

  return (
    <Tab
      className={classNames(classes.root, className, classes[size])}
      value={value}
      label={
        <Badge {...badgeProps}>
          {label}
        </Badge>
      }
      disableRipple
      {...rest}
    />
  );
};

FacetTab.defaultProps = {
  className: '',
  size: 'md',
  actionNeeded: false,
  errorCount: undefined,
  warningCount: undefined,
};

FacetTab.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.node.isRequired,
  actionNeeded: PropTypes.bool,
  errorCount: PropTypes.string,
  warningCount: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
  value: PropTypes.string.isRequired,
};

export default withStyles(styles)(FacetTab);
